module.exports = __webpack_public_path__ + "img/icon-acciones.e752a96e.svg";